import { render, staticRenderFns } from "./interpretation.vue?vue&type=template&id=2f13d56e&scoped=true&"
import script from "./interpretation.vue?vue&type=script&lang=js&"
export * from "./interpretation.vue?vue&type=script&lang=js&"
import style0 from "./interpretation.vue?vue&type=style&index=0&id=2f13d56e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13d56e",
  null
  
)

export default component.exports